import axios from 'axios'

export default {
    uploadDocument(documents) {
        const config = {
            headers: { 'content-type': 'multipart/form-data' }
        }

        return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/documents', documents, config).then((response) => {
            return response
        })
    }
}
